import {Component, ElementRef, Injector, OnInit, Renderer2, ViewChild} from '@angular/core';
import * as moment from 'moment';
import {PomodoroRepository} from '../Models/PomodoroRepository';
import {FormControl} from '@angular/forms';
import {Pomodoro} from '../Models/Pomodoro';
import {CategoryService} from '../services/category.service';
import {PomodoroService} from '../services/pomodoro.service';
import {TaskService} from '../services/task.service';
import {Category} from '../Models/category.model';
import {CdkDragDrop, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';
import {MatDialog} from '@angular/material/dialog';
import {TourComponent} from '../dialogs/tour/tour.component';

@Component({
  selector: 'app-for-debug',
  templateUrl: './for-debug.component.html',
  styleUrls: ['./for-debug.component.css']
})

export class ForDebugComponent implements OnInit {
  @ViewChild('editButton') editButton: ElementRef;
  @ViewChild('categoryTag') categoryTag: ElementRef;
  @ViewChild('descriptionTag') descriptionTag: ElementRef;
  public isCategoryTagOpen = true;
  public isDescriptionTagOpen = false;
  public checkEditMode = false;
  public category = {
    title: '',
  };
  public selectedId: any;
  public myControl = new FormControl();
  public pomodoro = new Pomodoro();
  public pomodoroRepository: PomodoroRepository;
  public allTask: Pomodoro[];
  public haveToken: boolean;
  public check: any;

  constructor(public categoryService: CategoryService,
              private pomodoroService: PomodoroService,
              injector: Injector,
              private taskService: TaskService,
              private dialog: MatDialog) {
    this.pomodoroRepository = PomodoroRepository.getInstance(injector);
  }
  ngOnInit(): void {
    const now = new Date();
    // @ts-ignore
    const myTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 24, 0, 0, 0) - now;
    setTimeout(() => {location.reload(); }, myTime);
    const token = localStorage.getItem('token');
    if (token !== null) {
      this.haveToken = true;
      this.pomodoroRepository.getTokenDoneTime();
      this.taskService.getListOfUsersTask().subscribe(
        (data) => {
          this.pomodoroRepository.todoPomodoros = data.data.todo;
          this.pomodoroRepository.donePomodoros = data.data.done;
        }
      );
      this.categoryService.getListOfUsersCategory().subscribe(
        (data) => {
          this.pomodoroRepository.categories = data;
          // console.log(data);
        }
      );
    } else {
      this.haveToken = false;
    }
    this.pomodoroRepository.saveToLocalStorage();
    setTimeout(() => {
      this.askForTour();
    }, 500);
    // this.askForTour();
  }
  saveToCategories(i): void{
    this.pomodoroRepository.categories.push(i);
    this.categoryService.syncCategory(this.pomodoroRepository.categories).subscribe();
    this.pomodoroRepository.save();
  }
  addItem(): void {
    this.pomodoro.isEdit = false;
    this.pomodoroRepository.addItem(this.pomodoro);
    this.pomodoro = new Pomodoro();
  }

  removeItemFromDone(item): void {
    this.pomodoroRepository.removeFromDone(item);
  }

  removeItemFromTodo(item): void {
    this.pomodoroRepository.removeFromTodo(item);
  }

  changeDes(item): void{
    item.isEdit = !item.isEdit;
  }

  showInput(i: any): any{
    i.isEdit = true;
    console.log(i);
    localStorage.setItem('taskWhoWantsToEdit', JSON.stringify(i));
    this.selectedId = i.id;
  }
  backToDes(item): void{
    item.isEdit = false;
    this.pomodoroRepository.save();
    this.selectedId = null;
  }
  increaseCount(p: Pomodoro): void {
    this.pomodoroRepository.increaseCount(p);
  }

  decreaseCount(p: Pomodoro): void {
    this.pomodoroRepository.decreaseCount(p);
  }

  DoneCounter(): void {
    return this.pomodoroRepository.getDonePomodoros().length;
  }

  getTodoPomodoros(): any {
    return this.allTask;
  }
  displayFn(c: Category): string {
    return c && c.title ? c.title : '';
  }
  drop(event: CdkDragDrop<Pomodoro[]>): void {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);
    }
    this.pomodoroRepository.save();
  }
  myLog(c: Category): any{
    if (!c) {
      return '';
    }
    return c.title;
  }
  getTokenDoneTime(): any{
    this.taskService.getTodayTask().subscribe(
      (data) => {
        this.pomodoroRepository.getTodayProp = data.data.done;
        this.pomodoroRepository.todaySumHour = data.sum_length;
        this.pomodoroRepository.finalDone = moment().startOf('day').add(this.pomodoroRepository.todaySumHour, 'minutes').format('HH:mm');
      }
    );
  }
  askForTour(): any{
    this.dialog.open(TourComponent);
  }
  firstToSecond(): any{
    this.pomodoroRepository.ctlOne = false;
    this.pomodoroRepository.ctlTwo = true;
  }
  secondToFirst(): any{
    this.pomodoroRepository.ctlOne = true;
    this.pomodoroRepository.ctlTwo = false;
  }
  secondToThird(): any{
    this.pomodoroRepository.ctlTwo = false;
    this.pomodoroRepository.ctlThree = true;
  }
  thirdToSecond(): any{
    this.pomodoroRepository.ctlTwo = true;
    this.pomodoroRepository.ctlThree = false;
  }
  thirdToFour(): any{
    this.pomodoroRepository.ctlThree = false;
    this.pomodoroRepository.ctlFour = true;
  }
  fourToThree(): any{
    this.pomodoroRepository.ctlThree = true;
    this.pomodoroRepository.ctlFour = false;
  }
  fourToFive(): any{
    this.pomodoroRepository.ctlFour = false;
    this.pomodoroRepository.startTour = false;
    // this.pomodoroRepository.ctlThree = false;
  }
  fiveToFour(): any{
    this.pomodoroRepository.ctlFour = true;
    this.pomodoroRepository.ctlFive = false;
  }
  fiveToSix(): any{
    this.pomodoroRepository.ctlFour = false;
    this.pomodoroRepository.ctlFive = true;
  }
  sixToFive(): any{
    this.pomodoroRepository.ctlFive = true;
    this.pomodoroRepository.ctlSix = false;
  }
  sixToSeven(): any{
    this.pomodoroRepository.ctlFive = false;
    this.pomodoroRepository.ctlSix = true;
  }
  sevenToSix(): any{
    this.pomodoroRepository.ctlSix = true;
    this.pomodoroRepository.ctlSeven = false;
  }
  sevenToEight(): any{
    this.pomodoroRepository.ctlSix = false;
    this.pomodoroRepository.ctlSeven = true;
  }
  eightToSeven(): any{
    this.pomodoroRepository.ctlEight = false;
    this.pomodoroRepository.ctlNine = true;
  }
  eightToNine(): any{
    this.pomodoroRepository.ctlEight = false;
    this.pomodoroRepository.ctlNine = true;
  }
  nineToEight(): any{
    this.pomodoroRepository.ctlNine = false;
    this.pomodoroRepository.ctlTen = true;
  }
  nineToTen(): any{
    this.pomodoroRepository.ctlNine = false;
    this.pomodoroRepository.ctlTen = true;
  }
  endTour(): any{
    this.pomodoroRepository.ctlOne = false;
    this.pomodoroRepository.startTour = false;
    localStorage.setItem('tourMode', String(this.pomodoroRepository.startTour));
  }
}
